import { render } from "./ProfileCard.vue?vue&type=template&id=8b9ef0b8&scoped=true"
import script from "./ProfileCard.vue?vue&type=script&lang=js"
export * from "./ProfileCard.vue?vue&type=script&lang=js"

import "./ProfileCard.vue?vue&type=style&index=0&id=8b9ef0b8&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b9ef0b8"]])

export default __exports__